import { render, staticRenderFns } from "./categoryTab.vue?vue&type=template&id=0b5579a0&scoped=true&"
import script from "./categoryTab.vue?vue&type=script&lang=js&"
export * from "./categoryTab.vue?vue&type=script&lang=js&"
import style0 from "./categoryTab.vue?vue&type=style&index=0&id=0b5579a0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5579a0",
  null
  
)

export default component.exports